// extracted by mini-css-extract-plugin
export default {"tooltip":"yU-z","arrow":"zU-z"};